<template>
	<div>
		<section class="mt-md-5 mt-3 mb-3 mb-md-4 banner-description">
			<div class="justify-content-center site-description-slider">
				<div class="slider-mainvisual mx-0">
					<slick ref="slick" :options="slickOptions">
						<a class="main-slide" v-for="item in sList" :key="item.index" :href="getLink(item)">
							<img :src="host+item.slider_img.img_url">
						</a>
					</slick>
				</div>
			</div>
		</section>
		<section :class="isLap ? 'row mx-4':''">
			<div  v-if="isLap" class="col-3">
				<section class="container py-3 filter">
					<div class="category mt-2 mb-3 canClick">
						<div ref="category" class="catname py-1 px-2" data-name="▼" @click="toggle('cat')">カテゴリ</div>
						<transition name="accordion" @before-enter="acBeforeEnter" @enter="acEnter" @before-leave="acBeforeLeave" @leave="acLeave">
							<ul class="pl-4" v-show="opencat">
								<li class="mt-3" v-for="category in cList" :key="category.index" @click="filterMove('cat',category.category_classname)">{{category.category_displayname}}</li>
							</ul>
						</transition>
					</div>
					<div class="category canClick">
						<div ref="artist" class="catname py-1 px-2" data-name="▼" @click="toggle('art')">アーティスト</div>
						<transition name="accordion" @before-enter="acBeforeEnter" @enter="acEnter" @before-leave="acBeforeLeave" @leave="acLeave">
							<ul class="pl-4" v-show="openart">
								<li class="mt-3" v-for="artists in aList" :key="artists.index" @click="filterMove( 'art',artists.category_classname)">{{artists.category_displayname}}</li>
							</ul>
						</transition>
					</div>
				</section>
				<section class="container tw" ref="twitterEmbed">
					<a class="twitter-timeline" data-lang="ja" data-height="1300" data-chrome="noheader nofooter" data-dnt="true" href="https://twitter.com/k1stshop?ref_src=twsrc%5Etfw">Post by k1stshop</a>
				</section>
			</div>
			<div :class="isLap ? 'col-9':''">
				<info></info>
				<product></product>
				<section class="more my-3">
					<div :class="isLap ? 'w-50':'w-75'">
						<button class="btn btn-white btn-block" @click="toProduct()">商品一覧へ</button>
					</div>
				</section>
				<section class="container py-3 filter" v-if="!isLap" :class="isLap ? '':'px-4 mb-5'">
					<div class="category mt-2 mb-3 canClick">
						<div ref="category" class="catname py-1 px-2" data-name="▼" @click="toggle('cat')">カテゴリ</div>
						<transition name="accordion" @before-enter="acBeforeEnter" @enter="acEnter" @before-leave="acBeforeLeave" @leave="acLeave">
							<ul class="pl-4" v-show="opencat">
								<li class="mt-3" v-for="category in cList" :key="category.index" @click="filterMove('cat',category.category_classname)">{{category.category_displayname}}</li>
							</ul>
						</transition>
					</div>
					<div class="category canClick">
						<div ref="artist" class="catname py-1 px-2" data-name="▼" @click="toggle('art')">アーティスト</div>
						<transition name="accordion" @before-enter="acBeforeEnter" @enter="acEnter" @before-leave="acBeforeLeave" @leave="acLeave">
							<ul class="pl-4" v-show="openart">
								<li class="mt-3" v-for="artists in aList" :key="artists.index" @click="filterMove( 'art',artists.category_classname)">{{artists.category_displayname}}</li>
							</ul>
						</transition>
					</div>
				</section>
				<news></news>
				<section class="more my-3">
					<div :class="isLap ? 'w-50':'w-75'">
						<button class="btn btn-white btn-block" @click="toNews()">ニュース一覧へ</button>
					</div>
				</section>
			</div>
		</section>
	</div>
</template>

<style>
	.btn-white{
		border-color: #3e3c43;
	}
	.main-slide img{
		width: 50vw;
		/*overflow-y: hidden;*/
		/*height: 40vh;*/
		height: auto;
	}
	@media(max-width: 1024px){
		.main-slide img{
			width: 60vw;
			/*overflow-y: hidden;*/
			/*height: 40vh;*/
			height: auto;
		}
	}
	.tw{
		margin-top:5vh;
	}
	.catname{
		border-bottom: solid 2px #ccc;
		color: #6c757d;
		font-weight:bold;
		position:relative;
	}
	.catname::after{
		content: attr(data-name);
		position: absolute;
		right: 3%;
	}
	.category li{
		margin:1vh 0 0;
		color: #555;
		border-bottom: solid 1px #eee;
		font-size: 95%;
	}
	.category ul{
		overflow: hidden;
	}
	.accordion-enter, .accordion-leave-to{
		opacity: 0;
		transition: 600ms ease-in-out;
	}
	.accordion-enter-to, .accordion-leave{
		opacity: 1;
		transition: 600ms ease-in-out;
	}
	.more{
		justify-content: center;
		display: flex;
	}
</style>

<script>
import product from './products.vue'
import slick from 'vue-slick'
import news from './news.vue'
import info from './infomation.vue'
export default{
	data(){
		return{
			slickOptions:{
				slidesToShow: 1,
				autoplay: true,
				autoplaySpeed: 4000,
				arrows: false,
				centerMode: true,
				centerPadding: '20%',
				dots: true,
			},
			twOption:{
				// tweetLimit:'3',
				conversation:'none',
				width:'400',
				height:'1200',
				chrome:'noheader,nofooter',
			},
			sList:[],
			aList:[],
			cList:[],
			host:process.env.VUE_APP_IAM,
			opencat: false,
			openart: false,
			// isLap:true,
			// winWidth:window.innerWidth,
		}
	},
	components:{
		'product': product,
		'news': news,
		'slick': slick,
		'info':info,
	},
	created(){
		this.$store.commit('CHANGE_CATEGORY','0')
		this.$store.commit('CHANGE_ARTISTS','0')
		this.getJson()
	},
	mounted(){
		this.setTw()
	},
	methods:{
		setTw(){
			let twJs = document.createElement('script')
			twJs.src = 'https://platform.twitter.com/widgets.js'
			this.$refs.twitterEmbed.appendChild(twJs)
		},
		async getJson(){
			await this.$axios
			.get(this.$uri)
			.then((response) => {
				if(response.data.is_maintenance == true){
					window.location.href="/maintenance/maintenance.html"
				}else{
					this.sList = response.data.slider_list
					this.cList = response.data.category_master
					this.aList = response.data.artists_master
					this.reInit()
				}
			})
			.catch(() => {
				window.location.href="/error/error.html"
			})
		},
		getLink(json){
			if(json.slider_link != ""){
				return json.slider_link
			}else if(json.slider_out_link != ""){
				return json.slider_out_link
			}
		},
		next() {
			this.$refs.slick.next();
		},
		prev() {
			this.$refs.slick.prev();
		},
		reInit() {
			this.$refs.slick.destroy();
			this.$nextTick(() => {
				this.$refs.slick.create();
			});
		},
		toggle(clicked) {
			if(clicked=='cat'){
				let data = this.$refs.category.dataset
				this.opencat = !this.opencat
				if(data.name == '▼'){
					this.$set(data,'name','▲')
				}else{
					this.$set(data,'name','▼')
				}
			}else if(clicked=='art'){
				let data = this.$refs.artist.dataset
				this.openart = !this.openart
				if(data.name == '▼'){
					this.$set(data,'name','▲')
				}else{
					this.$set(data,'name','▼')
				}
			}
		},
		acBeforeEnter: function(el) {
			el.style.height = '0';
		},
		acEnter: function(el) {
			el.style.height = el.scrollHeight + 'px';
		},
		acBeforeLeave: function(el) {
			el.style.height = el.scrollHeight + 'px';
		},
		acLeave: function(el) {
			el.style.height = '0';
		},
		filterMove(status,to){
			if(status == 'cat'){
				this.$router.push('/products?cat='+to)
			}else if(status == 'art'){
				this.$router.push('/products?artist='+to)
			}
		},
		toProduct(){
			this.$router.push('/products')
		},
		toNews(){
			this.$router.push('/news')
		},
	},
	computed:{
		isLap(){
			if(window.innerWidth >= 1024){
				return true
			}else{
				return false
			}
		}
	},
}
</script>